import { useMsal } from "@azure/msal-react";
import { Autocomplete } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import useAuthenticatedPage from "../../hooks/useAuthenticatedPage";
import { handleKeyDown } from "../../shared/utils";
import "./layout.css";

const Header = ({ caseID }) => {
	const options = [
		{ label: "Wedge Builder", Id: "wedge" },
		{ label: "Gap Analysis", Id: "gap" },
	];

	const [isOpen, setIsOpen] = useState(false);
	const { moduleId } = useParams();

	const { userRole, userName } = useAuthenticatedPage();
	const { instance } = useMsal();

	const navigate = useNavigate();

	const onModuleSelection = (newValue) => {
		navigate(`/${newValue.Id}/wb-home`);
	};

	const handleLogout = () => {
		setIsOpen(true);
	};

	const handleCancel = () => {
		setIsOpen(false);
	};

	const handleConfirmLogout = () => {
		setIsOpen(false);
		toast.success("You have successfully logged out");
		//sessionStorage.clear();
		localStorage.clear();
		instance.logoutRedirect({
			postLogoutRedirectUri: "/",
		});
	};

	const handleAdminPage = () => {
		navigate(`/${moduleId}/permanent-issue-register`);
	};

	const navigateToHome = () => {
		navigate("/wedge/wb-home");
	};

	// Find the current module, defaulting to first option if not found
	const currentModule = options.find((i) => i.Id === moduleId) || options[0];

	return (
		<>
			<nav className="navbar navbar-expand navbar-light bg-color topbar mb-4 static-top shadow">
				<div>
					<img
						className="logo"
						src="/img/FRPLogo.svg"
						alt="logo"
						onClick={navigateToHome}
						onKeyDown={(e) => handleKeyDown(e, navigateToHome)}
					/>
				</div>
				<div className="autoComplete-div">
					<Stack spacing={1} sx={{ width: 175 }}>
						<Autocomplete
							value={currentModule}
							disableClearable
							id="module-dropdown"
							options={options}
							sx={{ width: 250, minHeight: 1 }}
							ListboxProps={{ style: { maxHeight: 250 } }}
							onChange={(_e, v) => onModuleSelection(v)}
							isOptionEqualToValue={(option, value) =>
								option === value ||
								option.Id === value.Id ||
								option.label === value.label
							}
							getOptionLabel={(option) => option.label}
							renderOption={(props, option) => {
								return (
									<li {...props} key={option.Id}>
										<span className="autoComplete-list">{option.label}</span>
									</li>
								);
							}}
							renderInput={(params) => (
								<TextField {...params} variant="standard" size="small" />
							)}
						/>
					</Stack>
				</div>
				<span className="case-info">{caseID}</span>
				<ul className="navbar-nav ml-auto">
					<li className="nav-item dropdown no-arrow">
						<button
							type="submit"
							className="nav-link dropdown-toggle"
							id="userDropdown"
							data-toggle="dropdown"
							aria-haspopup="true"
							aria-expanded="false"
							style={{ height: "100%" }}
						>
							<span className="mr-2 d-none d-lg-inline user-text-color small">
								{userName}
							</span>
							<span className="avatar">
								{userName.length > 0
									? `${userName.substr(0, 1)}${
											userName.split(" ").length > 1
												? userName.split(" ")[1].substr(0, 1)
												: ""
										}`
									: ""}
							</span>
						</button>
						<div
							className="dropdown-menu dropdown-menu-right shadow animated--grow-in"
							aria-labelledby="userDropdown"
						>
							<div style={{ display: userRole === "ADMIN" ? "block" : "none" }}>
								<button
									type="submit"
									className="dropdown-item"
									data-toggle="modal"
									onClick={handleAdminPage}
								>
									<i className="fas fa-cogs fa-sm fa-fw mr-2 text-gray-400" />
									Permanent Issue Register
								</button>
								<div className="dropdown-divider" />
							</div>
							<button
								type="submit"
								className="dropdown-item"
								data-toggle="modal"
								onClick={handleLogout}
							>
								<i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400" />
								Logout
							</button>
						</div>
					</li>
				</ul>
			</nav>
			<Dialog
				open={isOpen}
				onClose={handleCancel}
				aria-describedby="alert-dialog-slide-description"
			>
				<DialogContent>
					<DialogContentText id="alert-dialog-slide-description">
						Are you sure you want to logout?
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleCancel}>Cancel</Button>
					<Button onClick={handleConfirmLogout}>Logout</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};
export default Header;
